export const LOADER_TRANSITION_DURATION = 500;

export const LOADER_LOGO_DURATION = 1000;

export const LOADER_PROGRESS_TRANSITION_DURATION = 500;

export const LOADER_HEIGHT = 391;

export const LOADER_HEIGHT_ASPECT = LOADER_HEIGHT / 936;

export const LOADER_WIDTH = 421;

export const LOADER_WIDTH_ASPECT = LOADER_WIDTH / 1920;
